/**
 * @constant
 * @type {{BALANCE: string, USER_NAME: string}}
 */
const LOGGEDIN_BINDING = {
    BALANCE: '#wallet',
    USER_NAME: '#username'
};


/**
 * @constant
 * @type {{LOGGEDIN_CGP: string, LOGOUT_BUTTON: string}}
 */
const LOGGEDIN_EVENTS_SELECTORS_ID = {
    LOGGEDIN_CGP: '#cgp_loggedin',
    LOGOUT_BUTTON: '#logout_button'
};

const POST_LOGIN_LAYOUT_CLASSES = {
    PC: {
        CASHIER: 'cgp-loggedin-pc-cashier-layout',
        GREETING: 'cgp-loggedin-pc-greeting-layout',
        DEFAULT: 'cgp-loggedin-pc-default-layout'
    },
    MOBILE: {
        CASHIER: 'cgp-loggedin-mobile-cashier-layout',
        GREETING: 'cgp-loggedin-mobile-greeting-layout',
        FULL: 'cgp-loggedin-mobile-full-layout',
        DEFAULT: 'cgp-loggedin-mobile-default-layout'
    }
}



export {LOGGEDIN_BINDING, LOGGEDIN_EVENTS_SELECTORS_ID, POST_LOGIN_LAYOUT_CLASSES};


